/**
 * Resolve effective branding from tenant data.
 * Prefer server-computed `branding` (single source of truth), fall back to whitelabel object.
 */
export function getWhitelabelConfig(store) {
  const branding = store?.branding;
  if (branding) {
    return {
      active: true,
      hidePoweredBy: Boolean(branding.hide_powered_by),
      brandName: branding.brand_name || store?.name || '',
      footerText: branding.footer_text || null,
      logoUrl: branding.logo_url || store?.logo_url || '',
      faviconUrl: branding.favicon_url || store?.store_extras?.favicon_url || '',
      customCss: branding.custom_css || '',
    };
  }

  const wl = store?.whitelabel || {};
  const active = Boolean(wl.is_enabled);

  return {
    active,
    hidePoweredBy: active && Boolean(wl.hide_powered_by),
    brandName: (active && wl.custom_brand_name) || store?.name || '',
    footerText: active && wl.custom_footer_text ? wl.custom_footer_text : null,
    logoUrl: (active && wl.custom_logo_url) || store?.logo_url || '',
    faviconUrl: (active && wl.custom_favicon_url) || store?.store_extras?.favicon_url || '',
    customCss: active ? (wl.custom_css || '') : '',
  };
}
